import { XYZ } from 'ol/source';

export const indexObj = {
  fons: [
    {
      // 00.fons topogràfic estandard
      tile: new XYZ({
        attributions: 'ICGC',
        url: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/estandard/MON3857NW/{z}/{x}/{y}.png',
        maxZoom: 30,
        crossOrigin: 'Anonymous',
        tileSize: 256,
        wrapX: false
      }),
      miniaturaCarto: require('../images/img-bg-carto-miniatura-02.jpg'),
      altMiniaturaCarto: 'miniatura cartografia topogràfic',
      infoMiniaturaCarto: 'Mapa base estàndard',
      dataMiniaturaCarto: 'Font: ICGC (Servei de mapa base)',
      lastResolution: 0.29858214173896974,
      tileName: 'icgc_mapa_estandard',
      dataUrl: 'https://www.icgc.cat/ca/Geoinformacio-i-mapes/Servei-de-Mapa-Base'
    },
    {
      // 01.fons estàndard gris
      tile: new XYZ({
        attributions: 'ICGC',
        url: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/estandard-gris/MON3857NW/{z}/{x}/{y}.png',
        maxZoom: 30,
        tileSize: 256,
        crossOrigin: 'Anonymous',
        wrapX: false
      }),
      miniaturaCarto: require('../images/img-bg-carto-miniatura-08.jpg'),
      altMiniaturaCarto: 'miniatura mapa estàndard gris',
      infoMiniaturaCarto: 'Mapa base estàndard gris',
      dataMiniaturaCarto: 'Font: ICGC (Servei de mapa base)',
      lastResolution: 0.29858214173896974,
      tileName: 'icgc_mapa_base_gris',
      dataUrl: 'https://www.icgc.cat/ca/Geoinformacio-i-mapes/Servei-de-Mapa-Base'
    },
    {
      // 03.fons Topogràfic clàssic
      tile: new XYZ({
        attributions: 'ICGC',
        url: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/topografic/MON3857NW/{z}/{x}/{y}.png',
        maxZoom: 30,
        tileSize: 256,
        crossOrigin: 'Anonymous',
        wrapX: false
      }),
      miniaturaCarto: require('../images/img-bg-carto-miniatura-04.jpg'),
      altMiniaturaCarto: 'miniatura cartografia vector tile',
      infoMiniaturaCarto: 'Mapa base topogràfic',
      dataMiniaturaCarto: 'Font: ICGC (Servei de mapa base)',
      tileName: 'topografic_classic',
      lastResolution: 0.14929107086948487,
      dataUrl: 'https://www.icgc.cat/ca/Geoinformacio-i-mapes/Servei-de-Mapa-Base'
    },
    {
      // 04.fons Topogràfic clàssic gris
      tile: new XYZ({
        attributions: 'ICGC',
        url: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/topografic-gris/MON3857NW/{z}/{x}/{y}.png',
        maxZoom: 30,
        tileSize: 256,
        crossOrigin: 'Anonymous',
        wrapX: false
      }),
      miniaturaCarto: require('../images/img-bg-carto-miniatura-07.jpg'),
      altMiniaturaCarto: 'miniatura cartografia fons fosc',
      infoMiniaturaCarto: 'Mapa base topogràfic gris',
      dataMiniaturaCarto: 'Font: ICGC (Servei de mapa base)',
      tileName: 'topografic_classic_gris',
      lastResolution: 0.14929107086948487,
      dataUrl: 'https://www.icgc.cat/ca/Geoinformacio-i-mapes/Servei-de-Mapa-Base'
    },
    {
      // 02.fons Ortofoto vigent
      tile: new XYZ({
        attributions: 'ICGC',
        url: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/orto/MON3857NW/{z}/{x}/{y}.png',
        maxZoom: 30,
        tileSize: 256,
        crossOrigin: 'Anonymous',
        wrapX: false
      }),
      miniaturaCarto: require('../images/img-bg-carto-miniatura-06.jpg'),
      altMiniaturaCarto: 'miniatura ortofoto vigent',
      infoMiniaturaCarto: 'Mapa base orto',
      dataMiniaturaCarto: 'Font: ICGC (Servei de mapa base)',
      tileName: 'orto_augmentada',
      lastResolution: 0.14929107086948487,
      dataUrl: 'https://www.icgc.cat/ca/Geoinformacio-i-mapes/Servei-de-Mapa-Base'
    },
    {
      // 05.fons ortofoto
      tile: new XYZ({
        attributions: 'ICGC',
        url: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/orto-hibrida/MON3857NW/{z}/{x}/{y}.png',
        maxZoom: 30,
        tileSize: 256,
        crossOrigin: 'Anonymous',
        wrapX: false
      }),
      miniaturaCarto: require('../images/img-bg-carto-miniatura-01.jpg'),
      altMiniaturaCarto: 'miniatura cartografia ortofoto',
      infoMiniaturaCarto: 'Mapa base orto híbrida',
      dataMiniaturaCarto: 'Font: ICGC (Servei de mapa base)',
      lastResolution: 0.29858214173896974,
      tileName: 'orto_hibrida',
      dataUrl: 'https://www.icgc.cat/ca/Geoinformacio-i-mapes/Servei-de-Mapa-Base'
    },
    {
      // 06.fons Administrativa simplificada
      tile: new XYZ({
        attributions: 'ICGC',
        url: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/administratiu/MON3857NW/{z}/{x}/{y}.png',
        maxZoom: 30,
        tileSize: 256,
        crossOrigin: 'Anonymous',
        wrapX: false
      }),
      miniaturaCarto: require('../images/img-bg-carto-miniatura-05.jpg'),
      altMiniaturaCarto: 'miniatura cartografia fons clar',
      infoMiniaturaCarto: 'Mapa base administratiu',
      dataMiniaturaCarto: 'Font: ICGC (Servei de mapa base)',
      lastResolution: 19.109257071294063,
      tileName: 'limits',
      dataUrl: 'https://www.icgc.cat/ca/Geoinformacio-i-mapes/Servei-de-Mapa-Base'
    }
  ],
  navHeight: 40,
  navHeightCollapsed: 80,
  alturaBtnCatalegBase: 20,
  alturaBtnSelectorFonsBase: 20,
  alturaBtnFav: 110,
  alturaMapControlsBase: 0
};
